"use client";
import React, { useState } from "react";

function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}

const FaqAccordion = ({ faqData }) => {
  const [open, setOpen] = useState(0);

  const handleOpen = (value) => setOpen(open === value ? 0 : value);

  return (
    <div className="mt-8 max-lg:mt-6 max-w-5xl mx-auto flex flex-col gap-3">
      {faqData?.map((item, i) => (
        <details
          key={i}
          open={open === i}
          className={`rounded-card border bg-bgCard px-5 py-4 transition-colors ${
            open === i ? "border-line-strong shadow-card-sm" : "border-line hover:border-line-strong"
          }`}
        >
          <summary
            onClick={(e) => {
              e.preventDefault();
              handleOpen(i);
            }}
            className="flex items-center justify-between gap-4 cursor-pointer list-none"
            aria-expanded={open === i}
          >
            <span className="faq-question font-medium text-textPrimary">{item.question}</span>
            <span className={`shrink-0 ${open === i ? "text-primary" : "text-textMuted"}`}>
              <Icon id={i} open={open} />
            </span>
          </summary>
          <div className="faq-answer pt-3 text-textSecondary leading-relaxed">{item.answer}</div>
        </details>
      ))}
    </div>
  );
};

export default FaqAccordion;

